var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('contest-beneficiaries-table',{attrs:{"announced":_vm.contestInfo.announced}}),_c('d-a-c-codes',{attrs:{"announced":_vm.contestInfo.announced}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }